import React from 'react';
import ModalQuestionComponent from './ModalQuestionComponent';
import { useQuestionForm } from './useQuestionForm';
import { ModalQuestionProps } from './types';
import { typesIcon, typesSupported } from './constants';

// Exportamos las constantes para mantener la compatibilidad con otros componentes que las utilizan
export { typesIcon, typesSupported };

const ModalQuestion: React.FC<ModalQuestionProps> = (props) => {
    const {
        open,
        onClose,
        saveLoad,
        idSurvey,
        idQuestion,
        question,
        loading,
        questionsDependency,
    } = props;

    const { formik, dependencies, questionDependency, isTextTypeQuestion } =
        useQuestionForm({
            idSurvey,
            idQuestion,
            question,
            questionsDependency,
            onClose,
            saveLoad,
        });

    return (
        <ModalQuestionComponent
            open={open}
            onClose={onClose}
            saveLoad={saveLoad}
            idSurvey={idSurvey}
            idQuestion={idQuestion}
            question={question}
            loading={loading}
            questionsDependency={questionsDependency}
            formik={formik}
            dependencies={dependencies}
            questionDependency={questionDependency}
            isTextTypeQuestion={isTextTypeQuestion}
        />
    );
};

export default ModalQuestion;
